import { getBoostMultiplier } from './boostMultiplier'
import { toScorable } from './scorable'
import { type PitchQualifierForForm, type GameCriteriaFormData, type QualifierForForm } from './types'
import { type GameCriteria, type GameQualifier, isEmpty, isDefined } from '@terros/common'

export const transformCriteriaFormValues = (values: GameCriteriaFormData): GameCriteria => {
  const { pointsPerMetric } = values
  const boostMultiplier = getBoostMultiplier(values)

  const scorable = toScorable(values)
  const qualifiers = getQualifiers(values)
  if (!scorable) throw new Error('Invalid scorable metric')

  const criteria: GameCriteria = {
    ...scorable,
    pointsPerMetric: Number(pointsPerMetric),
    boostMultiplier,
    qualifiers,
  }
  return criteria
}

const getQualifiers = (values: GameCriteriaFormData): GameQualifier[] | undefined => {
  const pitchQualifier = transformPitchQualifier(values.pitchQualifier)
  if (pitchQualifier) return pitchQualifier
  return transformQualifiers(values.qualifiers)
}

const transformQualifiers = (qualifiers?: QualifierForForm[]): GameQualifier[] | undefined => {
  if (isEmpty(qualifiers)) return
  return qualifiers
    .map((qualifier) => {
      const scorable = toScorable(qualifier)
      if (!scorable) return
      const updated: GameQualifier = {
        ...scorable,
        minPercent: Number(qualifier.minPercent) / 100,
      }
      return updated
    })
    .filter(isDefined)
}

const transformPitchQualifier = (pitchQualifier?: PitchQualifierForForm): GameQualifier[] | undefined => {
  if (isEmpty(pitchQualifier)) return

  const { field, perPitches, name } = pitchQualifier
  if (!perPitches || !field || !name) return

  const minPercent = 1 / perPitches

  const qualifier: GameQualifier = {
    field,
    name,
    minPercent: Number(minPercent),
    type: 'exists',
  }
  return [qualifier]
}
